import request from './request';

let baseUrl="http://localhost:9000"
baseUrl='https://1252077373-hz6o1j8fiy.ap-beijing.tencentscf.com'


export function getScoreByDay(data){

    return request({
        baseURL: baseUrl,
        url: `/getScoreOfDay`,
        method: 'get',
        params: data,
    });
}


export function addScoreRecord(data){

    return request({
        baseURL: baseUrl,
        url: `/addScore`,
        method: 'post',
        data: data,
    });
}

export function getScoreSumOfCurrentMonth(data){
    return request({
        baseURL:baseUrl,
        url:`/getScoreSumOfCurrentMonth`,
        method:'get',
        params:data
    })
}

export function searchScoreReasonsByCount(data){
    return request({
        baseURL:baseUrl,
        url:`/searchScoreReasonsByCount`,
        method:'get',
        params:data
    })
}